export default {
  SET_SHARE_USERS (state, accounts) {
    state.accounts = accounts
  },
}
